import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { VitebskRegionWithLoader } from './loaders';
import { getCitiesByRegion } from '../../../actions/city/thunks';
import { RegionTypes } from '../../../types/Models/City/City';

export const VitebskRegion = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getCitiesByRegion(RegionTypes.VITEBSK));
    }, []);

    return <VitebskRegionWithLoader />;
};
